/* eslint-disable */
import bi1_data_validation from '../base_i1_datavalidation'
import { RC, CR, AJRS } from '../base_i2_success_codes'
import base_i3_log from '../base_i3_logging'
import { ajax } from 'noquery-ajax'

function createWatchdogUser(user_email, firstName, lastName, firebase_uid) {
    return new Promise(function (resolve, reject) {
        var return_msg = "";
        var debug_data = [];
        var task_id = "p2s1t3_CreateNewUser"
        var return_value = null;
        ajax({
            url: window.G_watchdog_auth_domain + '/console/p2s1t3-post_new_user_form',
            method: 'POST',
            dataType: "text",
            data: {
                "email": user_email,
                "first_name": firstName,
                "last_name": lastName,
                "firebase_uid": firebase_uid,
                 'account_type': '/console/createdefaultuser.html'
            },
            success: function (result) {
                if (result.toLowerCase().includes('success')) {
                    resolve(JSON.stringify({ success: RC.success, return_msg: return_msg, debug_data: debug_data }));
                    //this has to be done since this is a legacy call an doesn't have auth caching
                    window.G_firebase_auth.bi5VerifyToken();
                } else {
                    return_msg += "ajax request succeeded but payload indicates failure"
                    debug_data.push(JSON.stringify(result));
                    base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
                    //this has to be done since this is a legacy call an doesn't have auth caching
                    window.G_firebase_auth.bi5VerifyToken();
                    resolve(JSON.stringify({ success: RC.general_failure, return_msg: return_msg, debug_data: debug_data }));
                }
            }, error: function (result) {
                if (result.status === 401) {
                    window.G_firebase_auth.bi5forceTokenRefresh();
                }
                return_msg += "ajax request succeeded but payload indicates failure"
                debug_data.push(JSON.stringify(result));
                base_i3_log(G_username, G_ip, G_page_id, task_id, RC.firebase_failure, return_msg, debug_data);
                //this has to be done since this is a legacy call an doesn't have auth caching
                window.G_firebase_auth.bi5VerifyToken();
                reject(JSON.stringify({ success: RC.general_failure, return_msg: return_msg, debug_data: debug_data }));
            }

        })

    });
};


export default createWatchdogUser


// WEBPACK FOOTER //
// ./src/watchdog_includes/legacy_calls/p2s1t3_CreateNewUser.js